module.exports = __webpack_public_path__ + "img/image.16ddd82e.svg";